import React from "react";

export default function Delivery()
{
    window.location.href="https://delivery.baumlanus.com.ar";
    return "";
                
}                               